module.exports = __webpack_public_path__ + "static/media/up_triangle.cc2443b1.svg";